export interface ReportManagementPutRequest {
  id: number;
  date: string; // "YYYY-MM-DD"
  employeeCode: number;
  employeeName: string;
  projectId: number;
  projectNumber: string;
  projectName: string;
  manHoursCategory: 'A' | 'B' | 'C' | 'D' | 'E' | '';
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number;
}

export const EmptyReportManagementPutRequest: ReportManagementPutRequest = {
  id: 0,
  date: '',
  employeeCode: 0,
  employeeName: '',
  projectId: 0,
  projectNumber: '',
  projectName: '',
  manHoursCategory: '',
  startTime: '',
  endTime: '',
  manHoursTotal: 0,
};

export interface FormatReportManagementPutRequest {
  id: number;
  date: string; // "YYYY-MM-DD"
  projectId: number;
  manHoursA: boolean;
  manHoursB: boolean;
  manHoursC: boolean;
  manHoursD: boolean;
  manHoursE: boolean;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number;
}

export const formatReportManagementPutRequest = (
  item: ReportManagementPutRequest
): FormatReportManagementPutRequest => {
  return {
    id: item.id,
    date: item.date,
    projectId: item.projectId,
    manHoursA: item.manHoursCategory === 'A',
    manHoursB: item.manHoursCategory === 'B',
    manHoursC: item.manHoursCategory === 'C',
    manHoursD: item.manHoursCategory === 'D',
    manHoursE: item.manHoursCategory === 'E',
    startTime: item.startTime,
    endTime: item.endTime,
    manHoursTotal: item.manHoursTotal,
  };
};
